import * as React from 'react';
import { UIText2, IconChevronRight16 } from '@cian/ui-kit';
import cn from 'clsx';

import { IWithDeviceTypeProps, withDeviceType } from '../../../../utils/withDeviceType';

import * as styles from './styles.css';

interface ISberPremierDetailsButtonProps extends IWithDeviceTypeProps {
  text: string;
  onClick: () => void;
  icon?: string;
}

const SberPremierDetailsButton: React.FC<ISberPremierDetailsButtonProps> = ({ text, icon, onClick, deviceType }) => {
  return (
    <button className={cn(styles['sber-button'], styles[deviceType])} type="button" onClick={onClick}>
      <span className={styles['label-area']}>
        {icon && <img className={styles['icon']} src={icon} alt="" decoding="async" loading="lazy" />}
        <UIText2 color="white_100">{text}</UIText2>
      </span>
      <span className={styles['action-area']}>
        <IconChevronRight16 color="white_100" />
      </span>
    </button>
  );
};

const SberPremierDetailsButtonWithDeviceType = withDeviceType(SberPremierDetailsButton);
export { SberPremierDetailsButtonWithDeviceType as SberPremierDetailsButton };
